import { render } from "./App.vue?vue&type=template&id=1586171a"
const script = {}

import exportComponent from "D:\\Desktop\\项目\\xiongxi\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__